import { useEffect } from 'react'
import { useCookieConsentContext } from './CookieConsentContext'
import { DD_RUM } from 'src/shared/js/external/datadog'

declare global {
  interface Window {
    DD_RUM: DD_RUM | undefined
  }
}

/**
 * This component handles cookie consent for Datadog.
 */
const DatadogConsentHandler = () => {
  const { ethycaInitialized, analyticsConsent } = useCookieConsentContext()

  useEffect(() => {
    if (!ethycaInitialized || !window.DD_RUM) {
      return
    }
    if (analyticsConsent) {
      window.DD_RUM.onReady(() => {
        window.DD_RUM!.setTrackingConsent('granted')
      })
    } else {
      window.DD_RUM.onReady(() => {
        window.DD_RUM!.setTrackingConsent('not-granted')
      })
    }
  }, [ethycaInitialized, analyticsConsent])
  return null
}

export default DatadogConsentHandler
